import {
  Component,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import Product from 'src/app/model/product/product';
import { CollectionHelper } from 'src/app/helpers/collection-helper';
import DateHelper from 'src/app/helpers/date-helper';

@Component({
  selector: 'placement-header',
  templateUrl: './placement-header.component.html',
  styleUrls: ['./placement-header.component.scss']
})
export class PlacementHeaderComponent implements OnInit, OnChanges {
  @Input()
  products: Product[];

  someProductsExecuted: boolean = false;
  earliestPlacementDate: Date;
  earliestExecutionDate: Date;

  ngOnInit() {
    if (CollectionHelper.isPopulated(this.products)) {
      this.checkProductExecution(this.products);
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    const products = changes['products'];
    if (
      !products.isFirstChange() &&
      CollectionHelper.isPopulated(products.currentValue)
    ) {
      this.checkProductExecution(products.currentValue);
    }
  }

  checkProductExecution(products: Product[]) {
    let someProductsExecuted = false;
    let earliestPlacementDate = null;
    let earliestExecutionDate = null;
    for (const product of products) {
      if (
        product.productPlacement != null &&
        product.productPlacement.executionComplete
      ) {
        someProductsExecuted = true;
        earliestExecutionDate = DateHelper.min(
          earliestExecutionDate,
          product.productPlacement.executionDate
        );
      } else if (product.productPlacement != null && !someProductsExecuted) {
        earliestPlacementDate = DateHelper.min(
          earliestPlacementDate,
          product.productPlacement.actualPlacementDate
        );
      }
    }
    this.someProductsExecuted = someProductsExecuted;
    this.earliestPlacementDate = earliestPlacementDate;
    this.earliestExecutionDate = earliestExecutionDate;
  }
}
